import { render, staticRenderFns } from "./ImportMirror.vue?vue&type=template&id=63265abf"
import script from "./ImportMirror.vue?vue&type=script&lang=js"
export * from "./ImportMirror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports